import { loadStripe, StripeElementLocale } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import getConfig from 'next/config';
import useI18n from '@hooks/i18n/useI18n';
import useStripeOptions from '@hooks/vendor/useStripeOptions';

const { publicRuntimeConfig } = getConfig();
const stripePromise = loadStripe(publicRuntimeConfig.stripeApiKey);

const withStripe = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
) => {
  const WithStripe: React.FC<P> = (props) => {
    const { locale } = useI18n();
    const { elements } = useStripeOptions();

    return (
      <Elements
        stripe={stripePromise}
        options={{ locale: locale as StripeElementLocale, ...elements }}
      >
        <WrappedComponent {...props} />
      </Elements>
    );
  };

  return WithStripe;
};

export default withStripe;
